<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               @click="showModal(showAddFunding)"
               :ids="ids"
               :disabled="disabled"
               v-tooltip="tooltip">
      Add Funding
    </ed-button>
    <ed-modal title="Add Funding" :show="showAddFunding" @close="showModal(showAddFunding), fundingAmount = ''" @confirm='addFunds' primary-button="Add">
      <div slot="body" class='add-funding-overlay'>
        <p class="small">Add a one-time amount to this EvedPay Card Account</p>
        <label>Funding Amount</label>
        <ed-input type='money' amount v-model='fundingAmount' @input="(value) => fundingAmount = value" />
      </div>
    </ed-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      fundingAmount: '',
      showAddFunding: false
    }
  },
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    accountId: ''
  },
  methods: {
    async addFunds() {
      if (this.fundingAmount) {
        try {
          const response = await this.api.post(`evedpaycards/accounts/${this.accountId}/add-funding`, {
            Amount: parseFloat(this.fundingAmount),
            IsImmediate: true
          })

          if (response.status === 200) {
            this.$emit('success')
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.addFundsError()
      }
      this.fundingAmount = ''
    },
    addFundsError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: { from: 'top', align: 'center' },
        timeout: 0,
        message: 'Please fill out all the fields.'
      })
    },
    showModal(showAddFunding) {
      this.showAddFunding = !showAddFunding
    }
  }
}
</script>

<style lang='scss' scoped>
.add-funding-overlay {
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/AddFunding.vue